import React from 'react';
import { Header as BasisHeader } from 'basis';
import { useAppContext } from 'hooks';
import { byCountry } from 'utils';
import { NZHeaderLogo } from 'components/logo/nz/NzGemLogo';
import { AuHeaderLogo } from 'components/logo/au/AuLogo';

export const Header: React.FC = () => {
  const { state } = useAppContext();

  return <BasisHeader>{byCountry(state, { nz: NZHeaderLogo, au: AuHeaderLogo })}</BasisHeader>;
};

// @ts-ignore
Header.ID = 'MyHeader';
// @ts-ignore
Header.HEIGHT_MAP = BasisHeader.HEIGHT_MAP;
